export class Personel {
    public Id: string;
    public Name: string;
    public Surname: string;
    public TcNumber: string;
    public SgkNumber: string;
    public CompanyName: string;
    public Email: string;
    public LockoutEnabled: boolean;
    public Role: string;
}

export class PersonelLogin {
    public access_token: string;
    public token_type: string;
    public user_name: string;
    public user_role: string;
    public first_login: string;
}

export class PdfDto {
    public FileName: string;
    public Content: Blob;
}

export class DocumentTypeListDto {
    public Id: number;
    public Name: string;
}

export class UserMessageModel {
    public UserId: string;
    public Caption: string;
    public Message: string;
}

export class Doc {
    DocumentName: string;
    Id: string;
    Month: string;
    Year: string;
    IsRead:boolean;
}

export class UserPermissionsDto {
    Id: number;
    SicilNo: string;
    MernisNo: string;
    Hakedis: number;
    Kullanilan: number;
    Kalan: number;
}

export class PersonelList {
    public personelList: Array<Personel>;
}

export class Notify {
    public Id: number;
    public AdminNameSurname: string;
    public CreateDate: Date;
    public Caption: string;
    public Message: string;
    public IsRead: boolean;
    public IsReadDate: Date;
}

export class SignInDto {
    public userName: string;
    public password: string;
}

export class PersonelTable {
    public Name: string;
    public Surname: string;
    public TcNumber: string;
    public SgkNumber: string;
    public Email: string;
}
